import Cookies from 'js-cookie';
import { fetch_with_auth } from './auth_fetch';

const submit_request_topic = async (topic, type, data) => {
    try {
        const url = `/api/${topic}/request/${type}`;
        const response = await fetch(url, {
            method: "POST",
            headers: {
                'Authorization':  `Bearer ${Cookies.get('accessToken')}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json'       
            },
            body: JSON.stringify(data),
        });
        const result = await response.json();
        if (result) {
            return [response.status, result];
        } else {
            return [500, null];
        }
    } catch (error) {
        return [500, null];
    }
};

export const submit_new_wazaren_request = async (data) => {
    const result = await submit_request_topic("wazaren", "new", data);
    return result;
}

export const submit_update_wazaren_request = async (data) => {
    const result = await submit_request_topic("wazaren", "update", data);
    return result;
}

export const submit_new_wotageishi_request = async (data) => {
    const result = await submit_request_topic("wotageishi", "new", data);
    return result;
}

export const submit_update_wotageishi_request = async (data) => {
    const result = await submit_request_topic("wotageishi", "update", data);
    return result;
}

export const submit_new_organization_request = async (data) => {
    const result = await submit_request_topic("organization", "new", data);
    return result;
}

export const submit_update_organization_request = async (data) => {
    const result = await submit_request_topic("organization", "update", data);
    return result;
}

const view_request_topics = async (topic, lang, page) => {
    try {
        const url = `/api/${topic}/request/view?lang=${lang}&page=${page}`;
        const [success, result] = await fetch_with_auth(
            url,
            Cookies.get('accessToken'),
            Cookies.get('refreshToken'),
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'       
                },
            }
        );
        if (success) {
            const result_data = await result.response.json();
            return [result.response.status, result_data];
        } else {
            return [500, null];
        }
    } catch (error) {
        return [500, null];
    }
}

export const view_wazaren_request = async (lang, page) => {
    const result = await view_request_topics("wazaren", lang, page);
    return result;
}

export const view_wotageishi_request = async (lang, page) => {
    const result = await view_request_topics("wotageishi", lang, page);
    return result;
}

export const view_organization_request = async (lang, page) => {
    const result = await view_request_topics("organization", lang, page);
    return result;
}

